import React, { useEffect, useContext } from "react";
import { AppSettings } from "./../../config/app-settings.js";

function PagesComingSoon() {
  const context = useContext(AppSettings);

  useEffect(() => {
    context.setAppHeaderNone(true);
    context.setAppSidebarNone(true);
    context.setAppContentClass("p-0");

    return function cleanUp() {
      context.setAppHeaderNone(false);
      context.setAppSidebarNone(false);
      context.setAppContentClass("");
    };
  }, [context]);

  return (
    <>
      <div className="coming-soon coming-soon-content">
        <div className="flex-1 coming-soon-content">
          <span className="brand-img-text-dashboard text-theme">
            <img
              src="/assets/img/logo/hornetStrikeIcon.png"
              alt=""
              className="rounded-circle logo"
            />
          </span>
          <div className="d-flex flex-column">
            <div className="flex-1 mb-3">
              <h2 className="mb-3">We're coming soon!</h2>
              <p className="mb-4">
                We are working very hard on the new version of our site.
                <br /> It will bring a lot of new features. Stay tuned!
              </p>
              <div className="support-email text-center">
                <p className="mb-4">
                  For inquiries, please reach out to us at:
                  <br />
                  support@hornetstrike.com
                </p>
              </div>
              <div className="mb-1 small text-inverse text-opacity-50">
                * Stay tuned for the latest updates
              </div>
            </div>
            <div className="text-center small text-inverse text-opacity-50">
              &copy; 2025 HornetStrike Right Reserved
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PagesComingSoon;
